var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingwraper",class:{loadingwraper_inline: _vm.type === 'inline'}},[_c('div',{staticClass:"loading-icon icon-loading g_loading"}),_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }